module.exports = __webpack_public_path__ + "static/media/sound4.eb4bc216.mp3";